// --------------------------------------------------------------------------
// #230 Donation Tabs
// --------------------------------------------------------------------------
// Author:      Alix Richards, Mike Simmonds
// Email:       frontend@zonedigital.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2016, zonedigital.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var ref = { $root: options.context };

    function init() {
        // Fetch DOM references
        ref.$tabs = ref.$root.find('[data-binding="donation-tabs"]');
        ref.$tabContainer = ref.$root.find('[data-name="donation-holding-container"]');

        // Do we need to tabs?
        if (ref.$tabs.length > 1) {
            ref.$tabs.addClass('donation-block--tabs-are-go');

            // Create nav container
            ref.$nav = $('<ul class="donation-block__tab-nav"></ul>');

            // Find each header and add it to a list item, save this to an array
            ref.$tabs.each(function (index) {
                var $block = $(this).attr('data-block-index', index);
                var $header = $block.find('[data-name="donation-header"]');
                var $navItem = $('<li class="donation-block__tab-item" data-name="donation-tab-item" data-tab-index="' + index + '" />');

                // If the block is active, the nav item should be as well
                if ($block.hasClass('active')) {
                    $navItem.addClass('active');
                }

                // Move header inside nav item and add to nav
                $navItem.append($header).appendTo(ref.$nav);
            });

            // Add the nav to the page
            ref.$nav.insertBefore(ref.$tabContainer);

            // Listen to clicks to the nav, change active state
            ref.$nav.on('click', 'li', function () {
                // Find tab index
                var triggerIndex = $(this).index();

                // Update nav active state
                ref.$nav.find('li').removeClass('active').eq(triggerIndex).addClass('active');

                // Update tab active state
                ref.$tabs.removeClass('active').eq(triggerIndex).addClass('active');
            });
        } else {
            ref.$tabs.addClass('only-one-block');
        }

        // Focusing personalised donation should check the the associated radio option
        ref.$root.on('focus', '[data-name="personalised-donation"]', function () {
            var $textInput = $(this);
            var $radioInput = $textInput.parents('[data-name="radio-option"]').find('[data-target="custom-amount"]');

            // Check it, trigger change event
            if (!$radioInput.is(':checked')) {
                $radioInput.prop('checked', true).trigger('change', [true]);
            }
        });

        // Reset personalised donations
        ref.$root.on('change', '[data-name="radio-option"]', function (event, noFocus) {
            var $option = $(this);
            var $personalisedDonation = $option.find('[data-name="personalised-donation"]');

            // Make sure all personalised donation fields (except any inside this option) are reset
            ref.$root.find('[data-name="personalised-donation"]').not($personalisedDonation).val('');

            // If focus is true and option has a custom input, focus it
            if (!!$personalisedDonation.length && !noFocus) {
                $personalisedDonation.focus();
            }
        });

        ref.$root.on('change', '[data-name="personalised-donation"]', function (event) {
            event.stopPropagation();
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/donation-tabs.js
// module id = 272
// module chunks = 0